<template>
  <v-data-table
    :items="
      getDeliverySlips.filter(
        x => x.is_closed === false && x.is_deleted === false
      )
    "
    :items-per-page="10"
    :mobile-breakpoint="0"
    hide-default-footer
    hide-default-header
    :headers="headers"
    sort-by="date"
    :sort-desc="true"
    class="no-border"
    dense
    :loading="loading"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td width="140">
          <span class="caption">{{ item.date | dateLocalFormat }}</span>
        </td>
        <td>
          <span class="caption">
            {{ getSupplierName(item) }}
          </span>
        </td>
        <td>
          <v-row align="center" justify="end" no-gutters>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon color="warning" v-if="item.is_receive">
                  <v-icon small v-on="on">far fa-check-circle</v-icon>
                </v-btn>
              </template>
              Commande reçu mais en attente d'être fermé
            </v-tooltip>
            <v-btn
              icon
              small
              :to="{ name: 'DeliverySlipViewer', params: { id: item.id } }"
            >
              <v-icon small>fa-external-link-alt</v-icon>
            </v-btn>
          </v-row>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OrderGrid",
  props: {
    loading: {
      default: false
    }
  },
  computed: {
    ...mapGetters(["getDeliverySlips", "getIsAdmin", "getSuppliers"])
  },
  data() {
    return {
      headers: [
        { value: "date", text: "", width: 130 },
        { value: "supplier", text: "" },
        { value: "actions", text: "", width: 50 }
      ]
    };
  },
  methods: {
    getSupplierName(item) {
      const s = this.getSuppliers.find(
        x => x.id_fournisseur == item.fk_supplier
      );
      return s ? s.name_fournisseur : "";
    }
  }
};
</script>

<style></style>
